import { mapGetters,  mapMutations } from 'vuex'
import across from "@/config/components/across.js"
export const Mixins = {
    data() {
        return {
            loadingInstance:{},
            sortPorp:'',
        }
    },
    computed:{
        ...mapGetters('Home', [
            'allCollect',
            'collect'
        ]),
    },
    methods: {
        ...mapMutations('Home',[
            'SET_ACTIVE_NAV',
            'SET_ACCROSS_MAP'
        ]),
        msgerror(message){
            this.$message.error({message});
        }, 
        msgsuccess(message){
            this.$message.success({message});
        },
        msgwarning(message){
            this.$message.warning({message});
        },
        pageLoading(loading){ // 全屏遮罩
            let instance;
            if(loading){
                instance = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.6)',
                    customClass:'global-layer'
                });
            }else{
                instance = this.$loading()
                instance.close()
            }
        },
        selfLoadingOpen(dom){ // 根据所传dom元素遮罩
            this.$nextTick(()=>{
                if(!!document.querySelector(dom)){
                    this.loadingInstance = this.$loading({
                        target:document.querySelector(dom),
                        lock: false,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.6)',
                        fullscreen:false,
                    });
                }
            })
        },
        selfLoadingClose(){
            this.loadingInstance.close();
        },
        // 跳转缓存的tab页面
        linkHomeTab(parentCode,path,options=null){
            if(!parentCode || !path){
                return
            }
            let routeObj = {};
            for(let i = this.allCollect.length; i--;){
                let modules = this.allCollect[i];
                if(modules.moduleCode === parentCode){
                    for(let k = modules.children.length; k--;){
                        if(modules.children[k].path === path){
                            routeObj = JSON.parse(JSON.stringify(modules.children[k])); // 赋值模块对象
                        }
                    }
                    break;
                }
            }
            let openIndex = -2;
            if(this.collect.length > 0){
                for(let i=0; i<this.collect.length; i++){
                    if(this.collect[i].path === routeObj.path){ // 收藏列表中是否有该模块
                        openIndex = i;
                        break
                    }
                }
            }
            this.SET_ACTIVE_NAV(openIndex)
            across.$emit('addCollect',routeObj,'isOpen')
            !!options && this.SET_ACCROSS_MAP({path,options})
        },
        desc_sort(a, b){
            if(a[this.sortPorp] === undefined){
                a[this.sortPorp] = '';
            }
            if(b[this.sortPorp] === undefined){
                b[this.sortPorp] = '';
            }
            if(a[this.sortPorp] != '0' && Number(a[this.sortPorp]) === 0){
                a[this.sortPorp] = -Infinity
            }
            if(b[this.sortPorp] != '0' && Number(b[this.sortPorp]) === 0){
                b[this.sortPorp] = -Infinity
            }
            let val1 = Number(a[this.sortPorp])
            let val2 = Number(b[this.sortPorp])
            if(isNaN(val1) || isNaN(val2)){
                return
            }
            return val2 - val1;
        },
        asc_sort(a, b){
            if(a[this.sortPorp] === undefined){
                a[this.sortPorp] = '';
            }
            if(b[this.sortPorp] === undefined){
                b[this.sortPorp] = '';
            }
            if(a[this.sortPorp] != '0' && Number(a[this.sortPorp]) === 0){
                a[this.sortPorp] = Infinity
            }
            if(b[this.sortPorp] != '0' && Number(b[this.sortPorp]) === 0){
                b[this.sortPorp] = Infinity
            }
            let val1 = Number(a[this.sortPorp])
            let val2 = Number(b[this.sortPorp])
            if(isNaN(val1) || isNaN(val2)){
                return
            }
            return val1- val2;
        },
    },
}